import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  Button
} from '../../components';
import Grid from '@material-ui/core/Grid';

import css from './AboutPage.module.css';
import image from './about-us-1056.jpg';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Ollo',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
        <br/>
      
          <h1 className={css.pageTitle}>Comment ça marche ?</h1>
        <br/>
        <br/>
          <div className={css.contentWrapper}>
          
            <Grid container justify='space-between'>

                <Grid item xs={12}  md={5}>
                  <div className={css.boxWrapper}>

                  <p className={css.title1}>Je souhaite me garer 🚗</p>     


<p className={css.title2}>1. Je cherche la place qu’il me faut </p>

  <p className={css.text}>Entrez votre adresse de destination puis sélectionnez la place qui vous convient. Vous avez la possibilité de contacter notre service client 7j /7 - 24h24 ou votre hôte si vous avez besoin d’informations supplémentaires.</p>



<p className={css.title2}>
2. Je réserve en ligne
   </p>

<p className={css.text}>
Pas besoin d’attendre la réponse du propriétaire, les réservations sont instantanées. Un changement de programme ? Il est possible d’annuler gratuitement votre réservation jusqu’à 24h avant. 
 </p>


  <p className={css.title2}>
  3. Je prépare ma venue    </p>

  <p className={css.text}>
  Une fois que vous avez réservé, rendez-vous dans “Mes Réservations” en haut à droite. 
 Vous obtiendrez un document explicatif avec toutes les informations dont vous avez besoin (récupération des accès, numéro de la place etc).   </p>
  


 <p className={css.title2}>
 4. Je laisse un commentaire sur la plateforme
   </p>

<p className={css.text}>
A la fin de votre location, laissez un commentaire pour partager votre expérience à la communauté ollo !
</p>
<p className={css.whiteText}>asdfsdfasdf</p>
<a href={`${typeof window !== 'undefined' ? window.location.origin : ""}/s?address=Paris%2C%20France&bounds=48.9020129995121%2C2.46976999462145%2C48.8156060108013%2C2.22422400085346`}>
  <Button className={css.button}>TROUVEZ LA PLACE IDEALE</Button>
</a>


                  </div>

                </Grid>



                <Grid item xs={12}  md={5}>

                <div className={css.boxWrapper}>

                <p className={css.title1}>Je souhaite louer ma place 🤝</p>     


                <p className={css.title2}>1. Je dépose mon annonce gratuitement</p>

                  <p className={css.text}>Cliquez sur <span className={css.orangeText}>+Proposer ma place</span> pour déposer votre annonce en un clic. A la suite de votre demande, un membre de notre équipe prend contact avec vous pour finaliser avec vous votre annonce. </p>
                  {/* <p>
                  À la suite de cela, le city manager de votre ville prendra contact avec vous afin de déterminer la solution de remise des accès, s’assurer que le parking correspond aux critères ollo, prendre des photos… A la suite de cette étape, votre parking est prêt pour la mise en location !
                  </p> */}


                <p className={css.title2}>
                2. Je suis mes réservations en direct
                   </p>

                <p className={css.text}>
                Vous recevez un mail pour vous informer de chaque réservation pour votre place. L’avantage avec ollo, c’est que vous n’avez aucune action à réaliser. ollo s’occupe des arrivées / départs de vos locataires.                  </p>


                  <p className={css.title2}>
                  3. Je perçois le règlement                 
                   </p>

                  <p className={css.text}>
                  Vous recevez le montant de la transaction sur votre compte bancaire dans un délai de 1 à 3 jours après la fin de chaque réservation.                 </p>

                 <p className={css.title2}>
                 4. Je ne suis pas engagé
                   </p>

                <p className={css.text}>
                Depuis votre espace personnel, vous pouvez, à votre guise, mettre en pause (ou supprimer) votre annonce, et la réactiver quand vous le souhaitez.                </p>
                   <p className={css.whiteText}>sdfsdfsddf</p>
               <br/> 
                <a href={`${typeof window !== 'undefined' ? window.location.origin : ""}/l/draft/00000000-0000-0000-0000-000000000000/new/location`}>
                  <Button className={css.button2}>PROPOSER MA PLACE</Button>
                </a>

                </div>
                  
                </Grid>

            </Grid>
                
    
            
          </div>
       
       
       
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
